import useShopItems from 'containers/Shop/hooks/useShopItems'
import { useHistory, useParams } from 'react-router-dom'
import { selectBasketToPay } from '../basketSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import { useReduxSelector } from 'store'
import React from 'react'

const Shop: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const toPay = useReduxSelector(selectBasketToPay)
  const basket = useShopItems({ cartId: id })

  const { t } = useTranslation('basket')
  const { push } = useHistory()

  const values = Object.values(basket.list || {})

  return (
    <div className='orderInfoButton'>
      <div className='title group'>
        <div>
          <span>{t('shop')}</span>
        </div>
        {values.length > 0 && <span
          className='orderInfo__add'
          onClick={() => {
            push(`/order/${id}/shop`)
          }}>
          + {t('add')}
        </span>}
      </div>

      {values.length > 0
        ? <div className='orderInfo__items'>
          {values.map(({ identifier, name, categoryId }) => <div
            key={identifier}
            className='orderInfo__item --selected'>
            <div className='orderInfo__item__icon'>
              <i className='icon icon--shopping-bag' />
            </div>
            <div className='orderInfo__item__content'>
              <div className='orderInfo__item__title'>{name}</div>
              <div className='orderInfo__item__scope'>{t('price')}: {displayPrice(toPay[identifier]?.to_pay?.price_sum || 0)}</div>
            </div>
            <ArrowBtn
              showArrow={false}
              className='--secondary'
              text={t('change')}
              action={() => {
                push(`/order/${id}/shop${categoryId ? `/${categoryId}` : ''}`)
              }}
            />
          </div>)}
        </div>
        : <div className='orderInfo__button'>
          <button
            className='button --coupon'
            onClick={() => {
              push(`/order/${id}/shop`)
            }}>
            {t('addAddon')}
          </button>
        </div>}
    </div>
  )
}

export default Shop